import styles from './RateCard.module.scss';
import {
	BookingPermissionsSettings,
	LeadTimesSettings,
	PriceRules
} from '@components';
import { DEFAULT_RATE_CARD_RANGES } from '@types';

type TProps = {
	isDisabled?: boolean;
	type: keyof typeof DEFAULT_RATE_CARD_RANGES;
}

export const RateCardRules = (props:TProps) => {
	const {
		isDisabled = false,
		type
	} = props;
	return (
		<>
			<div className={styles.expanders}>
				<LeadTimesSettings isDisabled={isDisabled} type={type} />
				<BookingPermissionsSettings isDisabled={isDisabled} />
				<PriceRules isDisabled={isDisabled} type={type} />
			</div>
		</>
	);
}
